import Timeline from './Timeline'
import TemperaturePie from './TemperaturePie'
import TemperatureLegend from './TemperatureLegend'
import TemperatureBar from './TemperatureBar'
import DoubleBar from './DoubleBar'
import TemperatureTitle from './TemperatureChartTitle'
import LineLegend from './LineLegend'
import LineTitle from './LineChartTitle'

export default {
  Timeline,
  TemperaturePie,
  TemperatureLegend,
  TemperatureBar,
  DoubleBar,
  TemperatureTitle,
  LineLegend,
  LineTitle,
}



// WEBPACK FOOTER //
// ./src/components/UI/Chart/index.js